import React, { Component } from "react";
import PropTypes from "prop-types";
import { Header } from "semantic-ui-react";

import "./VotifyPlayback.css";
import {
  getProgressRatio,
  getCurrentProgressMs,
  getTrackDurationMs,
} from "./util";
import { getTruncatedString } from "../../../utils/utils";
import { NEXT_TRACK_COUNTDOWN_LIMIT_S } from "../../../constants";

class VotifyPartyHeaderTrackInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentProgressMs: getCurrentProgressMs(props.playback),
      prevTrack: props.playback.item,
    };

    this.showNextTrackCountDown = this.showNextTrackCountDown.bind(this);
    this.getTimeLeft = this.getTimeLeft.bind(this);
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      this.setState({ currentProgressMs: this.state.currentProgressMs + 1000 });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  UNSAFE_componentWillReceiveProps({ playback }) {
    console.log("UNSAFE_componentWillReceiveProps");
    if (
      this.props.playback.item &&
      playback.item.id !== this.props.playback.item.id
    ) {
      this.setState({
        currentProgressMs: getCurrentProgressMs(playback),
        prevTrack: playback.item,
      });
    } else {
      this.setState({ currentProgressMs: getCurrentProgressMs(playback) });
    }
  }

  showNextTrackCountDown() {
    return this.getTimeLeft() < NEXT_TRACK_COUNTDOWN_LIMIT_S * 1000;
  }

  getTimeLeft() {
    return (
      getTrackDurationMs(this.props.playback) - this.state.currentProgressMs
    );
  }

  render() {
    return (
      <div>
        {(this.showNextTrackCountDown() && this.props.nextTrack && (
          <PlayingTrackInfo
            headerName={"Next track"}
            track={this.props.nextTrack}
          />
        )) || (
          <PlayingTrackInfo
            headerName={"Currently playing"}
            track={this.props.playback.item}
          />
        )}
        <VotifyTrackProgressBar
          currentProgressMs={this.state.currentProgressMs}
          trackDurationMs={getTrackDurationMs(this.props.playback)}
        />
      </div>
    );
  }
}

VotifyPartyHeaderTrackInfo.propTypes = {
  playback: PropTypes.object.isRequired,
  nextTrack: PropTypes.object,
};

const VotifyTrackProgressBar = ({ currentProgressMs, trackDurationMs }) => (
  <div>
    <hr className="Votify-track-progress-bar progress-bar-background" />
    <hr
      className="Votify-track-progress-bar progress-bar-foreground"
      style={{
        width: `${getProgressRatio(currentProgressMs, trackDurationMs) *
          100}vw`,
      }}
    />
  </div>
);

VotifyTrackProgressBar.propTypes = {
  currentProgressMs: PropTypes.number,
  trackDurationMs: PropTypes.number,
};

const PlayingTrackInfo = ({ track, headerName }) => {
  return (
    <Header
      inverted
      className="Votify-title"
      style={{ margin: 0, marginTop: "16px" }}
    >
      <Header.Content>
        <Header.Subheader>{headerName}</Header.Subheader>
        {getTruncatedString(track.name, { length: 34 })}
        <Header.Subheader>
          {track.artists.map((artist) => artist.name).join(", ")}
        </Header.Subheader>
      </Header.Content>
    </Header>
  );
};

PlayingTrackInfo.propTypes = {
  track: PropTypes.object.isRequired,
  headerName: PropTypes.string.isRequired,
};

export default VotifyPartyHeaderTrackInfo;
